import { Route } from 'react-router';
import ContinueEditing from './continue_editing';

// eslint-disable-next-line react/prop-types
const NewBookingRoute = ({ component, ...routeProps }) => {
  const Component = component;

  return (
    <Route
      {...routeProps} // eslint-disable-line react/jsx-props-no-spreading
      render={() => (
        <>
          <Component />
          <ContinueEditing />
        </>
      )}
    />
  );
};

export default NewBookingRoute;
